import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import { webinarSingleUseAllowed } from '@/common/service/op-switch';

export const simulateSingleUseProPlan = (allPlanMap) => {
  if (!webinarSingleUseAllowed) return;
  const result = {
    billing_cycle: BILLING_CYCLE.ONE_TIME,
    category: 'pro_single_use',
    isSingleUse: true,
    type: planTypes.ZOOM_MEETING,
    parent_category: "PRO",
    onetime_plancode: 'zo_pro_single_use',
    onetime_plantype: -10000,
    onetime_amount: 0,
  };
  allPlanMap[ZOOM_MEETING_SUB_TYPES.SINGLE_USE_PRO] = result;
}

